import { useState } from "react";
import axios from "axios";
import {
  AppInput,
  AppSingleSelect,
  AppInputNumber,
  AppRemixIcon,
  AppModal,
  AppFileUploader,
} from "@/layout/AppComponents";
import { Formik } from "formik";
import styled from "styled-components";
import ReactDOMServer from "react-dom/server";
import Translator from "../../../components/helpers/Translator";
import colors from "../../../../constants/colors";
import minions from "../../../../minions/minions";
import { axiosPath } from "../../../../routing/helpers/router";

export default function QseReportDataSectionRow(props) {
  const {
    reportID,
    reportType,
    moduleBridgeHex,
    subModuleBridgeHex,
    plantHex,
    code,
    title,
    handleOnSetFieldValue,
    value = "",
    clarifications = "",
    comments = "",
    currentFiles = [],
    formFiles = [],
    removeFiles = [],
  } = props;
  const [showFilesModal, setShowFilesModal] = useState(false);

  // > TOGGLE REMOVE FILE
  const toggleRemoveFile = (values, setFieldValue, fileName) => {
    const updateRemoveFiles = values.removeFiles;

    if (updateRemoveFiles.includes(fileName)) {
      setFieldValue(
        "removeFiles",
        updateRemoveFiles.filter((fn) => fn !== fileName)
      );
    } else {
      updateRemoveFiles.push(fileName);
      setFieldValue("removeFiles", updateRemoveFiles);
    }
  };
  // < TOGGLE REMOVE FILE

  // > SAVE FORM
  const handleOnSubmit = (values) => {
    handleOnSetFieldValue(`${code}-files`, values.formFiles);
    handleOnSetFieldValue(`${code}-removeFiles`, values.removeFiles);
    setShowFilesModal(false);
  };
  // < SAVE FORM

  // > UPLOAD FILE
  const handleUpload = (values, setFieldValue, opt) => {
    const uploadFiles = Array.from(opt).filter(
      (f) =>
        !values.formFiles.includes(f.name) &&
        formFiles &&
        !formFiles.includes(f.name)
    );
    setFieldValue("formFiles", [...values.formFiles, ...uploadFiles]);
  };
  // < UPLOAD FILE

  // > DOWNLOAD FILE
  const handleDownloadFile = async (fileName) => {
    try {
      const response = await axios.post(
        axiosPath("api_r_user_module_qseReports_getFile"),
        {
          reportID,
          reportType,
          moduleBridgeHex,
          subModuleBridgeHex,
          plantHex,
          fileName,
          optionCode: code,
        }
      );
      window.open(response.data, "_blank");
      return response.data;
    } catch (err) {}
  };
  // < DOWNLOAD FILE

  return (
    <div className="row mb-4">
      <div className="col-12 col-lg-4">
        <div className="alert alert-light">
          {title}
          <span
            className="float-right pointer"
            title={
              currentFiles.length > 0
                ? `${currentFiles.length} files`
                : "Upload files"
            }
            onClick={() => setShowFilesModal(true)}
          >
            <AppRemixIcon
              icon={currentFiles.length > 0 ? "file" : "upload-2"}
            />{" "}
            {currentFiles.length > 0 && `x${currentFiles.length}`}
          </span>
        </div>
      </div>
      <div className="col-12 col-lg-2">
        {code === "emissionsMonitored" ||
        code === "emissionsLevelsUnderLimits" ||
        code === "noiseLevelsUnderLimits" ? (
          <AppSingleSelect
            title="Value"
            icon={<AppRemixIcon icon="check" />}
            options={[
              { label: "Yes", value: 1 },
              { label: "No", value: 2 },
            ]}
            onChange={(v) => handleOnSetFieldValue(`${code}-value`, v)}
            value={value}
            isClearable
          />
        ) : (
          <AppInputNumber
            title="Value"
            value={value}
            onChange={(v) => handleOnSetFieldValue(`${code}-value`, v)}
            icon={<AppRemixIcon icon="hashtag" noVariants />}
            isClearable
          />
        )}
      </div>
      <div
        className="col-12 col-lg-3"
        dangerouslySetInnerHTML={{ __html: clarifications }}
      />
      <div className="col-12 col-lg-3">
        <AppInput
          title="Comments"
          value={comments}
          icon={<AppRemixIcon icon="chat-1" />}
          onChange={(v) => handleOnSetFieldValue(`${code}-comments`, v)}
        />
      </div>
      <AppModal
        show={showFilesModal}
        title="Files"
        onClose={() => setShowFilesModal(false)}
      >
        <Formik
          initialValues={{
            removeFiles,
            formFiles,
          }}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize
          onSubmit={handleOnSubmit}
        >
          {({ setFieldValue, handleSubmit, values }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                {currentFiles.length > 0 && (
                  <div className="col-lg-12">
                    {currentFiles.length > 0 && <h6>Saved files</h6>}
                    <EvidenceFileList files={currentFiles.length > 0}>
                      {currentFiles.map((fileName) => (
                        <li key={fileName}>
                          <AppRemixIcon
                            className="pointer mr-3"
                            icon="delete-bin"
                            title={
                              values.removeFiles.includes(fileName)
                                ? ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="click.restore"
                                    />
                                  )
                                : ReactDOMServer.renderToString(
                                    <Translator
                                      file="module-legalCompliance"
                                      name="click.delete"
                                    />
                                  )
                            }
                            color={
                              values.removeFiles.includes(fileName)
                                ? colors.grey400
                                : colors.danger
                            }
                            onClick={() =>
                              toggleRemoveFile(values, setFieldValue, fileName)
                            }
                          />
                          {minions.files.fileIcon(
                            fileName,
                            true,
                            values.removeFiles.includes(fileName)
                              ? colors.grey400
                              : null,
                            "mr-2"
                          )}
                          <FileName
                            isRemoved={values.removeFiles.includes(fileName)}
                          >
                            {fileName}
                          </FileName>
                          <AppRemixIcon
                            className="pointer"
                            icon="download-2"
                            title="Download"
                            color={colors.primary}
                            onClick={() => handleDownloadFile(fileName)}
                          />
                        </li>
                      ))}
                    </EvidenceFileList>
                  </div>
                )}
                {currentFiles.length > 0 && values.formFiles.length > 0 && (
                  <div className="col-lg-12">
                    <hr />
                  </div>
                )}
                {values.formFiles.length > 0 && (
                  <div className="col-lg-12">
                    <h6>Preuploaded files</h6>
                    <div className="alert alert-warning mb-0">
                      Preuploaded files won't be uploaded until the upper right
                      button <b>Save</b> is clicked in the main page.
                    </div>
                    <EvidenceFileList files={false}>
                      {values.formFiles.map((f) => (
                        <li
                          key={f.name}
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="click.delete"
                            />
                          )}
                          onClick={() =>
                            setFieldValue(
                              "formFiles",
                              values.formFiles.filter(
                                (file) => file.name !== f.name
                              )
                            )
                          }
                        >
                          <AppRemixIcon
                            className="pointer mr-3"
                            icon="delete-bin"
                            color={colors.danger}
                          />
                          {minions.files.fileIcon(f.name, true, null, "mr-2")}
                          {f.name}
                        </li>
                      ))}
                    </EvidenceFileList>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-lg-12 pt-2">
                  <AppFileUploader
                    isMulti
                    placeholder={ReactDOMServer.renderToString(
                      values.formFiles.length === 0 ? (
                        <Translator
                          file="module-legalCompliance"
                          name="select.one.multiple.files"
                        />
                      ) : (
                        <Translator
                          file="general"
                          name="select.number.of.elements"
                          variables={{ elements: values.formFiles.length }}
                        />
                      )
                    )}
                    onChange={(opt) => handleUpload(values, setFieldValue, opt)}
                    btnText={<Translator file="general" name="search..." />}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="btn btn-primary float-right mt-3"
                  >
                    <Translator file="general" name="general.update" />
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </AppModal>
    </div>
  );
}

const EvidenceFileList = styled.ul`
  list-style: none;
  padding-left: 6px;
  background-color: ${(props) => (props.files ? colors.grey200 : "initial")};
  li {
    display: flex;
    align-items: center;
    border-top: 1px solid ${colors.grey300};
    padding: 8px 0;
    span {
      font-size: 12px;
      color: ${colors.primary};
    }
    .ri-download-2-line {
      margin: 0 10px 0 auto;
    }
  }
  li:first-child {
    border-top: 0;
  }
`;
const FileName = styled.span`
  text-decoration: ${(props) => (props.isRemoved ? "line-through" : "unset")};
`;
